import LocalizedClientLink from '@modules/common/components/localized-client-link';
import { Text } from '@modules/common/components/text';
import type { ProductCardVM } from 'types/view-models';
import Thumbnail from '../thumbnail';
import PreviewPrice from './price';

type ProductPreviewProps = {
  card: ProductCardVM;
  fetchPriority?: 'high' | 'low' | 'auto';
};

export default function ProductPreview({
  card,
  fetchPriority,
}: ProductPreviewProps) {
  return (
    <LocalizedClientLink href={`/${card.handle}`} className="group">
      <div
        data-testid="product-wrapper"
        className="flex flex-col h-full rounded-[8px] overflow-hidden bg-white"
      >
        <div className="relative">
          <Thumbnail
            as="div"
            thumbnail={card.thumbnail}
            images={card.images}
            size="full"
            fetchPriority={fetchPriority}
            alt={card.title}
            className="!rounded-none !shadow-none"
            imageClassName="mix-blend-multiply"
          />
        </div>
        <div className="flex flex-col flex-1 gap-2 px-3 py-4">
          <Text
            className="typography-paragraph text-fg-neutral-strong group-hover:text-fg-interactive-strong transition-colors duration-200"
            data-testid="product-title"
          >
            {card.title}
          </Text>
          <div className="mt-auto">
            {card.price && <PreviewPrice price={card.price} />}
          </div>
        </div>
      </div>
    </LocalizedClientLink>
  );
}
